import { defineStore } from "pinia";
import { Screen } from 'quasar';
import { computed } from "vue";

const STORE_NAME = 'adaptive';

export const useAdaptiveStore = defineStore(STORE_NAME, () => {

    const isDesktopScreen = computed(() => {
        if (process.env.SERVER) return true // ✅ По умолчанию desktop на сервере
        return Screen.gt.md
    })

    const isMobileScreen = computed(() => {
        if (process.env.SERVER) return false // ✅ По умолчанию не mobile на сервере
        return Screen.lt.lg
    })

    const isTabletScreen = computed(() => {
        if (process.env.SERVER) return false // ✅ По умолчанию не tablet на сервере
        return Screen.lt.md
    })

    const isPhoneScreen = computed(() => {
        if (process.env.SERVER) return false // ✅ По умолчанию не phone на сервере
        return Screen.lt.sm
    })

    return {
        isMobileScreen,
        isDesktopScreen,
        isTabletScreen,
        isPhoneScreen
    }
})

